"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("../../utils/colors");
var THEME_BASE_1 = __importStar(require("../../THEME_BASE"));
var LIGHT_THEME_COLOR_RATIO = [0.22, 0.385, 0.55, 0.715, 0.88];
var DARK_THEME_COLOR_RATIO = [0.15, 0.35, 0.55, 0.75, 0.95];
var colorShades = function (colorScheme, customBaseVariantColors) {
    var defaultVariantColors = THEME_BASE_1.default.colors[colorScheme].variant;
    if (!customBaseVariantColors || !Object.keys(customBaseVariantColors).length) {
        return defaultVariantColors;
    }
    var ratio = colorScheme === THEME_BASE_1.COLOR_SCHEME_LIGHT ? LIGHT_THEME_COLOR_RATIO : DARK_THEME_COLOR_RATIO;
    var customVariantColors = Object.fromEntries(Object.entries(customBaseVariantColors).map(function (_a) {
        var variantName = _a[0], color = _a[1];
        return ([
            variantName,
            [
                (0, colors_1.lighten)(color, ratio[3]),
                (0, colors_1.lighten)(color, ratio[2]),
                (0, colors_1.lighten)(color, ratio[1]),
                (0, colors_1.lighten)(color, ratio[0]),
                color,
                (0, colors_1.darken)(color, ratio[0]),
                (0, colors_1.darken)(color, ratio[1]),
                (0, colors_1.darken)(color, ratio[2]),
                (0, colors_1.darken)(color, ratio[3]),
                (0, colors_1.darken)(color, ratio[4]),
            ],
        ]);
    }));
    return __assign(__assign({}, defaultVariantColors), customVariantColors);
};
exports.default = colorShades;
